import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { ServiceDefaultNameInterface } from "@/api/Interfaces/ServiceDefaultNameInterface";
import MapService from "@/api/Services/MapService";
import MobileFacade from "@/facades/MobileFacade";
import vSelect from "vue-select";
import * as LogoClinicarx from "@/assets/images/Logo_nova.png";
import "vue-select/dist/vue-select.css";
import { AddressInterface, GeoCoordinatesInterface } from "@/api/Interfaces/MapInterface";
import SelectServiceDefaultNames from "@/components/Util/SelectServiceDefaultNames/SelectServiceDefaultNames.vue";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";
import { bus } from "@/main";

const cx_isMobile = MobileFacade.isMobile();
const SearchBarProps = Vue.extend({
  props: {
    address: {
      type: String,
      default: "",
    },
    zipCode: {
      type: String,
      default: null,
    },
    coordinates: {
      type: [Object as () => GeoCoordinatesInterface | null],
      default: null,
    },
    logo: {
      type: String,
      default: require("@/assets/images/Logo_nova.png"),
    },
    isInvalidCep: {
      type: Boolean,
      default: false,
    },
    isEmptyCep: {
      type: Boolean,
      default: false,
    },
    btnAtive: {
      type: Boolean,
      default: true,
    },
    cepForm: {
      type: Boolean,
      default: true,
    },
    statusButton: {
      type: String,
      default: "Inicial",
    },
    openMenu: {
      type: Boolean,
      default: cx_isMobile ? false : true,
    },
    ServiceDefaultNames: {
      type: Array,
      default: null,
    },
    selectedServiceDefaultName: {
      type: [Object as () => ServiceDefaultNameInterface],
      default: null,
    },
    headerLogo: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    showVsSearch: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true
    },
  },
});

@Component({
  name: "SearchBar",
  components: {
    "v-select": vSelect,
    "select-service-default-names": SelectServiceDefaultNames,
  },
})
export default class SearchBar extends SearchBarProps {
  cx_zipCode = this.zipCode;
  cx_address = this.address || window.sessionStorage.getItem("address");
  cx_isInvalidCep = this.isInvalidCep;
  cx_isEmptyCep = this.isEmptyCep;
  cx_btnAtive = this.btnAtive;
  cx_statusButton = this.statusButton;
  cx_coordinates = this.coordinates;
  cx_logo = this.logo;
  cx_cepForm = this.cepForm;
  cx_openMenu = this.openMenu;
  cx_ServiceDefaultNames = this.ServiceDefaultNames;
  cx_selectedServiceDefaultName = this.selectedServiceDefaultName;
  cx_header_logo = this.headerLogo || LogoClinicarx;
  cx_gettingGeoCoordinate = false;

  constructor() {
    super();
    this.cx_header_logo = this.headerLogo;
  }

  mounted() {
    bus.$on('loadingSearchBar', (value: boolean) => {
      this.loading = value;
    });
  }

  /**
   * -----------------------------------------
   * EVENTS
   * -----------------------------------------
   */

  @Watch("selectedServiceDefaultName")
  public watchSelectedServiceDefaultName(newValue: ServiceDefaultNameInterface): void {
    this.cx_selectedServiceDefaultName = newValue;
  }

  @Watch("zipCode")
  public watchZipCode(newValue: string): void {
    this.cx_isInvalidCep = false;
    this.cx_zipCode = "";
  }

  changeServiceDefaultName(serviceDefaultName: ServiceDefaultNameInterface): void {
    this.cx_selectedServiceDefaultName = serviceDefaultName;
    this.$emit("changeServiceDefaultName", this.cx_selectedServiceDefaultName);
  }

  async consultZipCode(): Promise<void> {
    this.cx_isInvalidCep = false;
    this.cx_isEmptyCep = false;

    if (this.cx_zipCode.length < 10) {
      //Se o CEP tiver menos de 10 caracter Botao fica desativado
      this.cx_btnAtive = false;
      return;
    } else {
      //Habilitar o botao a cep ter 10 digitos incluindo . e -
      this.cx_btnAtive = true;
    }

    this.cx_gettingGeoCoordinate = true;

    let debounceTime = 0;
    clearTimeout(debounceTime);
    debounceTime = setTimeout(() => {
      this.cx_zipCode = this.cx_zipCode.replace("-", "");
      this.cx_zipCode = this.cx_zipCode.replace(".", "");

      MapService.getLocationByZipCode(this.cx_zipCode)
        .then((response) => {
          const address: AddressInterface = response as AddressInterface;
          MapService.getGeoCoordinatesByAddress(address)
            .then((response: any) => {
              this.cx_coordinates = response as GeoCoordinatesInterface;

              this.cx_address =
                address.street && address.street != undefined ? `${address.street}, ` : "";
              this.cx_address += `${address.city}/${address.state}`;
              this.cx_gettingGeoCoordinate = false;
              
              this.search();
              
            })
            .catch(() => {
              this.cx_coordinates = null;
              this.cx_gettingGeoCoordinate = false;        
              this.cx_isInvalidCep = true;
              }
            );
        })
        .catch((error) => {
          console.error(error);
          this.cx_gettingGeoCoordinate = false;
          this.cx_isInvalidCep = true;

        });
    }, 10);
  }

  // Pesquisar o CEP
  search(): void {
    this.$emit(
      "changeSearch",
      this.cx_coordinates,
      this.selectedServiceDefaultName,
      this.cx_address,
      this.cx_zipCode,
      (this.cx_isEmptyCep = false),
      (this.cx_btnAtive = false)
    );
    this.cx_openMenu = cx_isMobile ? false : true;
    this.cx_isInvalidCep = false;
    this.cx_btnAtive = false;
    this.loading = true;
    window.sessionStorage.setItem("zipcode", JSON.stringify(this.cx_zipCode));
  }


  searchCondition(onClick?: boolean): void {
    GoogleAnalyticsEvents.searchLocation();
    if (onClick && (this.cx_zipCode?.length == 0 || this.cx_zipCode == null || this.cx_zipCode == "")) {
      this.cx_isEmptyCep = true;
    }

    else if (onClick && this.cx_zipCode?.length >= 1 && this.cx_zipCode?.length < 10) {
      this.cx_isInvalidCep = true;
      this.cx_isEmptyCep = false;
    }

    else if (onClick) {
      this.consultZipCode();
    }

    else {
      this.cx_isInvalidCep = false;
      this.cx_isEmptyCep = false;
    }
  }

  formatCurrency(str: string): string {
    return parseFloat(str).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  returnHome() {
    if (this.$route.name == "SearchServicesTenancy") {
      this.$router.push({ name: "Tenancy" });
    } else {
      this.$router.push({ name: "Home" });
    }
  }
}
